import request from "@/utils/request.js";

// 事件分析_车位总数
export const analyseparkTotalNum = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/parkTotalNum",
    params: data || {}
  });
};
// 事件分析_车辆总数
export const carcount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/count",
    params: data || {}
  });
};
// 车辆
export const carregion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/region",
    params: data || {}
  });
};
// 事件统计
export const eventregion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/event/region",
    params: data || {}
  });
};

// 告警统计
export const cluecountByRegion = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/zaxf/clue/countByRegion",
    params: data || {}
  });
};

// 车辆分析——车辆颜色
export const carColor = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/color",
    params: data || {}
  });
};

// 车辆分析——车流量统计
export const carFlow = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/carflow",
    params: data || {}
  });
};

// 车辆分析——车辆设备抓拍
export const carEquimentcount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/equimentcount",
    params: data || {}
  });
};
// 车辆分析——车辆告警
export const carAlarm = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/alarm",
    params: data || {}
  });
};
// 车辆分析——车辆总数
export const carCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/count",
    params: data || {}
  });
};
// 车辆分析——本市车辆
export const carThisCity = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/thisCity",
    params: data || {}
  });
};
// 车辆分析——外省车辆
export const carOtherCity = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/otherCity",
    params: data || {}
  });
};
// 车辆分析——使馆车辆
export const carDiplomatic = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/car/diplomatic",
    params: data || {}
  });
};